export const determineTenant = () => {
    if (
        window.location.origin.toLowerCase().indexOf('investceo') >= 0 ||
        window.location.origin.toLowerCase().indexOf('localhost') >= 0
    ) {
        return 'investceo';
    }
    return 'alm';
}